import { Outpost } from "./outpost";
import {OutpostStatus} from "./OutpostStatus";

export abstract class OutpostRepository {
  getOutposts: (tenantId?: number) => Promise<Outpost[]>;
  getStatuses: (tenantId?: number) => Promise<OutpostStatus[]>;
  startSession: (outpostId: string) => Promise<{ iframeUrl: string }>;
}
